import { render, staticRenderFns } from "./ContractRequest.vue?vue&type=template&id=d54ba1d8&lang=pug"
import script from "./ContractRequest.vue?vue&type=script&lang=js"
export * from "./ContractRequest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports